<template>
    <widget-card :icon="QrCode" :loading="loading" :title="trans('dashboard.v2.critical_locations.title')">
        <template v-if="debug" #header-end>
            <jet-button class="btn-icon" variant="secondary" @click="showDebugInfo = !showDebugInfo">
                <icon name="cil-bug" />
            </jet-button>
        </template>
        <div v-if="locations.length > 0" class="d-flex align-items-start gap-4 overflow-x-auto">
            <checkpoint-status
                v-for="checkpoint in locations"
                :key="checkpoint.name"
                :areas="checkpoint.areas"
                :checkpointName="checkpoint.name"
                :metrics="checkpoint.metrics"
            />
        </div>
        <empty-widget-state v-else-if="!loading" :text="trans('dashboard.v2.critical_locations.no_locations')" />
    </widget-card>
    <debug-view v-if="debug" v-model="showDebugInfo" title="Critical Locations<br/><small>Debug Info</small>">
        <pre style="background-color: #fefefe">{{ locations }}</pre>
    </debug-view>
</template>

<script setup>
import { trans } from '@/mixins/i18n.js';
import WidgetCard from '@/Pages/DashboardV2/Components/WidgetCard.vue';
import CheckpointStatus from '@/Pages/DashboardV2/Components/CriticalLocations/CheckpointStatus.vue';
import QrCode from '../../../../icons/QrCode.vue';
import { computed, onMounted, ref } from 'vue';
import EmptyWidgetState from '@/Pages/DashboardV2/Components/EmptyWidgetState.vue';
import { $http } from '@/bootstrap';
import JetButton from '@/Jetstream/Button.vue';
import DebugView from '@/Components/DebugView.vue';

const props = defineProps({
    widgetData: {
        type: Object,
        required: true,
        default: () => ({}),
    },
    filters: Object,
});

const dataUrl = computed(() => props.widgetData.dataUrl);

const loading = ref(true);
const locations = ref([]);
const debug = computed(() => new URLSearchParams(window.location.search).get('debug') === '1');
const showDebugInfo = ref(false);

onMounted(async () => {
    try {
        loading.value = true;
        const url = new URL(dataUrl.value, window.location.origin);
        if (debug.value) {
            url.searchParams.append('debug', '1');
        }

        const response = await $http.get(url.toString());
        locations.value = response.data;
    } catch (error) {
        console.error('Failed to fetch asset status data:', error);
    } finally {
        loading.value = false;
    }
});
</script>
